import { useEffect, useState } from "react";

// Decode a JWT's `exp` (seconds) into an absolute expiry time in ms.
const decodeExpiry = (token: string | null): number | null => {
  if (!token) return null;
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;
    const json = JSON.parse(
      atob(payload.replace(/-/g, "+").replace(/_/g, "/")),
    );
    return typeof json?.exp === "number" ? json.exp * 1000 : null;
  } catch {
    return null;
  }
};

const format = (ms: number): string => {
  const total = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
};

// Live mm:ss countdown to the current access token's expiry. Re-reads the token
// each tick, so it resets automatically when a silent refresh issues a new one.
export const SessionCountdown = () => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const expiry = decodeExpiry(localStorage.getItem("accessToken"));
  if (!expiry) return null;

  const remaining = expiry - now;

  return (
    <span
      className={`sidebar__expiry${remaining <= 0 ? " sidebar__expiry--expired" : ""}`}
      title="Access token expires in"
    >
      {format(remaining)}
    </span>
  );
};
